import { render } from "./FaceSliderQRWithBackgroundImage.vue?vue&type=template&id=547a8aed&scoped=true"
import script from "./FaceSliderQRWithBackgroundImage.vue?vue&type=script&lang=js"
export * from "./FaceSliderQRWithBackgroundImage.vue?vue&type=script&lang=js"

import "./FaceSliderQRWithBackgroundImage.vue?vue&type=style&index=0&id=547a8aed&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-547a8aed"

export default script